import React, { useEffect, useState } from "react";
import "../../css/DLT.css";
import EntityModal from './EntityModal';
import EntityIDs from '../dlt/EntityIDs';
import SenderIDs from '../dlt/SenderIDs';
import Template from '../dlt/Template';
import SenderIDModal from "./SenderIDModal";
import TemplateModal from "./TemplateModal";
import { useLocation } from 'react-router-dom';
import { useSelector } from "react-redux";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import AssignedVendor from "./AssignedVendor";
import {isOperationRole} from "../../utils";

function CustomTabPanel({ children, active }) {
  return <div className={`tab-pane fade ${active ? "show active" : ""}`}>{children}</div>;
}

const DLT = () => {
  const loggedInUserName = sessionStorage.getItem("username");
  const isCust = !isOperationRole();
  
  const [activeTab, setActiveTab] = useState(isCust ? "entityIDs" : "assignedVendor");
  const [showModalEntity, setShowModalEntity] = useState(false);
  const [showModalSender, setShowModalSender] = useState(false);
  const [showModalTemplate, setShowModalTemplate] = useState(false);
  const { user } = useSelector((state) => state.auth);
  console.log("user",user);
    
  const location = useLocation();
  const { customerCode, name, assignedVendorCode } = location.state || {};

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };

  const openModal = () => setShowModalEntity(true);
  const closeModal = () => setShowModalEntity(false);
  const openModalSender = () => setShowModalSender(true);
  const closeModalSender = () => setShowModalSender(false);
  const openModalTemplate = () => setShowModalTemplate(true);
  const closeModalTemplate = () => setShowModalTemplate(false);
  const [vendorData, setVendorData] = useState([]);

  const fetchVendorData = () => {
    const payload = {
      username: loggedInUserName,
      vendorId: "",
      vendorName: "",
      smsType: "",
      fromDate: "",
      toDate: "",
      status: ["Active"],
    };

    axiosPostApi(
      `${apiList.FETCH_VENDOR_DATA}?&pageSize=${10}&pageNo=${1}`,
      payload
    )
      .then((response) => {
        if (
          response?.data?.status === true &&
          response?.data?.respCode === "00"
        ) {
          const vendorData = response?.data?.data;
          setVendorData(vendorData ?? []);
        } else {
          setVendorData([]);
        }
      })
      .catch((error) => {
        CustomAlert({
          title: "Error",
          text: "An error occurred while fetching the data. Please try again later.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      });
  };

  useEffect(() => {
    if (!isCust) {
      fetchVendorData();
    }
  }, []);

  return (
    <div className="card p-2">
       <div className="d-flex justify-content-between align-items-center first-tab-controls">
        <div className="d-flex gap-3">
          <div>
            <label htmlFor="custCodeInput">Company Code</label>
            <input
              type="text"
              id="custCodeInput"
              className="form-control"
              value={customerCode || ''}
              readOnly
            />
          </div>
          <div>
            <label htmlFor="custName">Company Name</label>
            <input
              type="text"
              id="custName"
              className="form-control"
              value={name || ''}
              readOnly
            />
          </div>
        </div>
      </div>

      <ul className="nav nav-tabs dlt-tab-nav mt-2">
        {
          vendorData.length > 0 && (
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "assignedVendor" ? "active" : ""}`}
                onClick={() => handleTabChange("assignedVendor")}
              >
                Assigned Vendor
              </button>
            </li>
          )
        }
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "entityIDs" ? "active" : ""}`}
            onClick={() => handleTabChange("entityIDs")}
          >
            Entity ID
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "senderIDs" ? "active" : ""}`}
            onClick={() => handleTabChange("senderIDs")}
          >
            Sender IDs
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "template" ? "active" : ""}`}
            onClick={() => handleTabChange("template")}
          >
            Template
          </button>
        </li>
      </ul>

      <div className="tab-content dlt-tab-content !w-full">
        {
          vendorData.length > 0 ? (
            <CustomTabPanel active={activeTab === "assignedVendor"}>
              <AssignedVendor vendorData={vendorData} customerCode={customerCode} assignedVendorCode={assignedVendorCode} />
            </CustomTabPanel>
          ) : null
        }
        <CustomTabPanel active={activeTab === "entityIDs"}>
          <EntityIDs openModal={openModal} customerCode={customerCode} name={name}/>
        </CustomTabPanel>
        <CustomTabPanel active={activeTab === "senderIDs"}>
          <SenderIDs openModal={openModalSender} customerCode={customerCode} name={name}/>
        </CustomTabPanel>
        <CustomTabPanel active={activeTab === "template"}>
          <Template openModal={openModalTemplate} customerCode={customerCode} name={name}/>
        </CustomTabPanel>
      </div>

      <EntityModal show={showModalEntity} handleClose={closeModal} activeTab={activeTab} customerCode={customerCode} name={name}/>
      <SenderIDModal show={showModalSender} handleClose={closeModalSender} activeTab={activeTab} customerCode={customerCode} name={name}/>
      <TemplateModal show={showModalTemplate} handleClose={closeModalTemplate} activeTab={activeTab} customerCode={customerCode} name={name}/>
    </div>
  );
};

export default DLT;
